var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0090FF",
    d: "m12.923 10.824l-.316 1.607l3.007.402l-.211.753l-2.954-.402c-.211.654-.317 1.357-.58 1.96c-.264.703-.528 1.406-.845 2.06c-.422.854-1.16 1.457-2.162 1.607c-.58.101-1.213.05-1.688-.301c-.158-.1-.317-.301-.317-.452c0-.201-.004-.437.264-.553s.378-.034.528.05c.158.151.316.352.422.553c.316.402.738.452 1.16.15c.475-.401.739-.954.897-1.506c.316-1.206.633-2.362.896-3.567v-.202l-2.795-.402l.105-.753l2.902.402l.368-1.557l-3.006-.453l.106-.803l3.112.402c.105-.302.158-.553.264-.804c.263-.905.527-1.809 1.16-2.613s1.371-1.306 2.479-1.256c.475 0 .95.151 1.266.503c.053.05.158.15.158.25c0 .202 0 .453-.158.604c-.211.15-.475.1-.686-.1c-.158-.151-.264-.302-.422-.453c-.316-.402-.791-.452-1.16-.1a3.2 3.2 0 0 0-.686.954c-.37 1.055-.633 2.16-1.002 3.266l2.901.402l-.211.753z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFil);
export default __webpack_public_path__ + "static/media/fil.d7684e4687bbbea731a4ff0e2d9fe409.svg";
export { ForwardRef as ReactComponent };